import { BulkAction } from 'labstep-web/components/Entity/Search/BulkActions';
import { DefaultSort } from 'labstep-web/components/Entity/Table/SortOptions/utils';
import { Filter } from 'labstep-web/constants/filters';

export const bulkActions = [
  BulkAction.tag,
  BulkAction.delete,
  BulkAction.transfer_ownership,
  BulkAction.share,
  BulkAction.update_template,
];

export const bulkActionsTemplate = [
  BulkAction.delete,
  BulkAction.transfer_ownership,
  BulkAction.share,
];

export const filters = [Filter.deleted];

export const sortOptions = {
  name: { label: 'Name', default_sort: DefaultSort.asc },
};
